import { createContext, type ReactNode, useContext, useEffect, useState } from "react";

/** A record page names itself in the breadcrumb: Operations › Orders › ORD-1042. */
const CrumbContext = createContext<(label: string | null) => void>(() => {});

export function CrumbProvider({
  children,
  onChange,
}: {
  children: ReactNode;
  onChange: (label: string | null) => void;
}) {
  return <CrumbContext.Provider value={onChange}>{children}</CrumbContext.Provider>;
}

/** Sets the record's crumb while the page is open. */
export function useRecordCrumb(label: string | null | undefined) {
  const set = useContext(CrumbContext);
  useEffect(() => {
    set(label ?? null);
    return () => set(null);
  }, [label, set]);
}

export function useCrumbState() {
  return useState<string | null>(null);
}
